<template>
  <div class="carro-guia">
    <vuestic-modal :large="true">
      <div slot="title">Carro Guia</div>
      <table class="table table-info">

      </table>
    </vuestic-modal>
  </div>
</template>

<script>
  import VuesticModal from "../../../vuestic-theme/vuestic-components/vuestic-modal/VuesticModal";

  export default {
    name: "carroGuia",
    components: {VuesticModal}
  }
</script>

<style scoped>

</style>
